import classNames from "classnames";
import styles from "./css/SegmentedControl.module.css";

export interface SegmentedOption<T extends string | number> {
  value: T;
  label: string;
}

interface SegmentedControlProps<T extends string | number> {
  options: SegmentedOption<T>[];
  value: T;
  onChange: (value: T) => void;
  "aria-label": string;
  size?: "sm" | "md";
  fullWidth?: boolean;
}

export default function SegmentedControl<T extends string | number>({
  options,
  value,
  onChange,
  size = "md",
  fullWidth = true,
  ...rest
}: SegmentedControlProps<T>) {
  return (
    <div
      role="radiogroup"
      aria-label={rest["aria-label"]}
      className={classNames(styles.group, styles[size], {
        [styles.fullWidth]: fullWidth,
      })}
      style={{
        gridTemplateColumns: `repeat(${options.length}, minmax(0, 1fr))`,
      }}
    >
      {options.map((option) => {
        const selected = option.value === value;
        return (
          <button
            key={String(option.value)}
            type="button"
            role="radio"
            aria-checked={selected}
            className={classNames(styles.segment, {
              [styles.selected]: selected,
            })}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
